const CustomSwitch: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  color?:
    | "default"
    | "alternative"
    | "dark"
    | "light"
    | "green"
    | "red"
    | "yellow"
    | "purple"
    | "blue"
    | "cyan"
    | "indigo"
    | "lime"
    | "pink"
    | "teal";
  size?: "xs" | "sm" | "md" | "lg";
}> = ({ checked, onChange, label, color = "default", size = "sm" }) => {
  // Map color prop to Tailwind classes for checked state
  const checkedBgMap: Record<string, string> = {
    default: "bg-primary-600",
    alternative: "bg-gray-200",
    dark: "bg-gray-800",
    light: "bg-gray-300",
    green: "bg-green-600",
    red: "bg-red-600",
    yellow: "bg-yellow-400",
    purple: "bg-purple-600",
    blue: "bg-blue-600",
    cyan: "bg-cyan-600",
    indigo: "bg-indigo-600",
    lime: "bg-lime-600",
    pink: "bg-pink-600",
    teal: "bg-teal-600",
  };
  // Unchecked state: always light gray for all colors
  const uncheckedBg = "bg-gray-200 border border-gray-300";
  const sizeMap = {
    xs: {
      switch: "w-7 h-4",
      knob: "after:h-3 after:w-3 after:top-[4px] after:left-[2px]",
    },
    sm: {
      switch: "w-9 h-5",
      knob: "after:h-4 after:w-4 after:top-[2px] after:left-[2px]",
    },
    md: {
      switch: "w-11 h-6",
      knob: "after:h-5 after:w-5 after:top-[2px] after:left-[2px]",
    },
    lg: {
      switch: "w-14 h-8",
      knob: "after:h-7 after:w-7 after:top-[2px] after:-left-[2px]",
    },
  };
  const s = sizeMap[size as keyof typeof sizeMap] || sizeMap.md;
  const bgClass = checked
    ? checkedBgMap[color] || checkedBgMap.default
    : uncheckedBg;
  return (
    <label className="relative inline-flex items-center cursor-pointer min-w-max">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div
        className={`${s.switch} ${bgClass} rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] ${s.knob} after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all`}
      ></div>
      {label && (
        <span className="ml-3 text-sm font-medium text-gray-900">{label}</span>
      )}
    </label>
  );
};

export default CustomSwitch;
